import { observer } from 'mobx-react'
import React from 'react'
import DaoVM from './DaoVM'
import { Button, Loader } from 'ui-framework'
import ExternalLink from 'shared-components/ExternalLink'
import { links } from 'bzx-common/src/config/appConfig'
import { getDate } from 'app-lib/dateUtils'

const loader = (
  <div className="flex-center">
    <Loader quantityDots={3} sizeDots="small" />
  </div>
)

export function Proposals({ vm }: { vm: DaoVM }) {
  return (
    <div className="panel--simple md-padded-2 margin-bottom-1">
      <h3 className="title-section panel__header">
        <div className="flex-between flex-wrap">
          <span>Latest Proposals</span>
          <ExternalLink className="link--discreet" href={links.daoSnapshot}>
            Vote on Snapshot
          </ExternalLink>
        </div>
      </h3>
      <div>
        {vm.proposals.length === 0 && vm.dao.proposalsPending && loader}
        {vm.dao.proposalsError && (
          <p className="txt-warning">Could not fetch the list of proposals.</p>
        )}

        {vm.proposals.map((proposal) => {
          const { data, dialogVM } = proposal
          return (
            <div key={data.id} className="margin-bottom-2">
              <h4 className="h3 flex-between">
                {data.title}
                <div>
                  <span className="dao__vote-status">{data.state}</span>
                </div>
              </h4>
              <div className="margin-bottom-1">
                {getDate(data.start)}
                <Button className="margin-left-05" variant="link" onClick={dialogVM.toggle}>
                  {dialogVM.visible ? 'Show less' : 'Show more'}
                </Button>
              </div>
              <p className="txt-explanation">
                {dialogVM.visible ? data.body : `${data.body.slice(0, 180)}…`}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default observer(Proposals)
